import { cn } from "@/lib/utils";

export const getCardBaseClasses = (hasActiveBadge?: boolean) => cn(
  "relative bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-600 rounded-lg pt-4 pb-3 px-3 sm:px-4 sm:pt-6 sm:pb-4 transition-all hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer shadow-sm hover:shadow-md overflow-visible"
);

export const getCardStatusBarClasses = (statusColor: string) => {
  // Extract the color from the status color class (e.g., "before:bg-yellow-500" -> "yellow-500")
  const colorMatch = statusColor.match(/bg-(\w+-\d+)/);
  const color = colorMatch ? colorMatch[1] : 'gray-500';
  
  return cn(`border-l-4 border-l-${color}`);
};

export const getCardHeaderClasses = () => cn(
  "flex items-start justify-between mb-1 sm:mb-2"
);

export const getCardTitleClasses = () => cn(
  "text-sm sm:text-base font-medium text-gray-900 dark:text-white flex-1 line-clamp-2 leading-tight"
);

export const getCardDateClasses = () => cn(
  "text-xs sm:text-sm text-gray-500 dark:text-gray-400 mb-1 sm:mb-2 leading-tight"
);

export const getCardMetadataClasses = () => cn(
  "flex items-center gap-3 sm:gap-4 text-xs sm:text-sm text-gray-600 dark:text-gray-300"
);

export const getCardActionButtonClasses = () => cn(
  "flex-shrink-0 p-1 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700 rounded transition-colors"
);

export const getCardActiveClasses = () => cn(
  "ring-2 ring-blue-500 dark:ring-blue-400 bg-blue-50 dark:bg-blue-900/20"
);

export const getCardDisabledClasses = () => cn(
  "opacity-50 cursor-not-allowed"
);

export const getCardFooterClasses = () => cn(
  "mt-1 space-y-1"
);

export const getCardFooterRowClasses = () => cn(
  "flex items-center justify-between"
);
